'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M2 17h20v2H2zm11.84-9.21c.1-.24.16-.51.16-.79 0-1.1-.9-2-2-2s-2 .9-2 2c0 .28.06.55.16.79C6.25 8.6 3.27 11.93 3 16h18c-.27-4.07-3.25-7.4-7.16-8.21z' });

var RoomService = function RoomService(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

RoomService = (0, _pure2.default)(RoomService);
RoomService.muiName = 'SvgIcon';

exports.default = RoomService;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/RoomService.js
// module id = 2784
// module chunks = 0